import { render, staticRenderFns } from "./HonorDetailPage.vue?vue&type=template&id=285edcc2&scoped=true"
import script from "./HonorDetailPage.vue?vue&type=script&lang=js"
export * from "./HonorDetailPage.vue?vue&type=script&lang=js"
import style0 from "./HonorDetailPage.vue?vue&type=style&index=0&id=285edcc2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285edcc2",
  null
  
)

export default component.exports